import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ElementRef, TemplateRef } from '@angular/core';
import { EditSettingsModel, GridLine, RowSelectEventArgs } from '@syncfusion/ej2-grids';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IAccountHead, IMerchandisDiscountDetailsActive, IAccType, IGetPermissionMandatoryField } from '../interface';
import { MerchandiseService } from 'src/app/services/merchandise.service';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { GeneralService } from 'src/app/services/general.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DiscountsService } from 'src/app/services/discounts.service';
import { EActionTypes, EElementTypes, EnumDiscount, EnumMerchDiscount } from '../enum';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-discount-page',
    templateUrl: './discount-page.component.html',
    styleUrls: ['./discount-page.component.scss'],
    standalone: false
})

export class DiscountPageComponent implements OnInit {

  @Input() DiscountList = [];
  @ViewChild('grid', { static: true }) griddata: GridComponent;
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
  @Output() selectedBox: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('templateDiscApplyOptions', { static: true }) discApplyOptionNotSelected: TemplateRef<any>;
  @ViewChild('templatePercentageValidation', { static: true }) PercentageValidation: TemplateRef<any>;
  @ViewChild('templateFixedValidation', { static: true }) FixedValidation: TemplateRef<any>;
  @ViewChild('templatemyModal', { static: true }) NewModal: TemplateRef<any>;

  startMinDate: Date;
  endMinDate: Date;
  eNumActionTypes = EActionTypes;
  eNumElementTypes = EElementTypes;

  EnumDiscount = EnumDiscount;
  EnumMerchDiscount = EnumMerchDiscount;
  public editSettings: EditSettingsModel;
  public filterSettings: Object;
  public lines: GridLine;
  discountForm: FormGroup;
  discountDetails: IMerchandisDiscountDetailsActive;
  RecivedID;
  records = [];
  AccountHeads: IAccountHead[];
  positiveNumberPattern = '[0-9][0-9]*';
  positiveNumberPattern1 = '^[0-9]+(?:\.[0-9]+)?$';
  modalRef: BsModalRef;
  validtaionModalRef: BsModalRef;
  newModalRef: BsModalRef;
  isDiscountNameExist = false;
  discountName = '';
  discountId = 0;
  isCodeReactivation: boolean;
  ReactivateId: number;

  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  discountReqList = [];

  constructor(
    private formBuilder: FormBuilder,
    private merchService: MerchandiseService,
    public generalService: GeneralService,
    private modalService: BsModalService,
    private discountService: DiscountsService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {

    this.startMinDate = new Date();
    this.endMinDate = new Date();
    this.isCodeReactivation = false;
    this.editSettings = { allowEditing: false, allowAdding: true, allowDeleting: true };
    this.filterSettings = { type: 'Menu' };
    this.GetAccountHeads();
    this.discountForm = this.formBuilder.group({
      Id: [''],
      Name: [''],
      Description: ['',[Validators.required, Validators.maxLength(500)]],
      Type: [''],
      Value: [''],
      StartDate: [''],
      EndDate: [''],
      AccountsHead: [EnumDiscount.DefaultAccountHead],
      ApplyatMoveIn: [false],
      ApplyatTransfer: [false],
      ApplytoExistingTenants: [false],
      ApplytorWalkInCustomers: [false],
      ApplyAutomatically: [''],
      Remarks: ['']

    });
    this.setMandatoryDiscountsField();
  }

  changeStartDate(value) {
    this.endMinDate = value;
    if ((this.discountForm.value.EndDate !== '') && (this.discountForm.value.EndDate != null)) {
      if (value > this.discountForm.value.EndDate) {
        this.discountForm.controls['EndDate'].setValue('');
      }
    }
  }

  onDiscountSubmit() {
    if ((this.discountForm.value.ApplyatMoveIn !== true) &&
      (this.discountForm.value.ApplyatTransfer !== true) &&
      (this.discountForm.value.ApplytoExistingTenants !== true) && (this.discountForm.value.ApplytorWalkInCustomers !== true)) {
      this.openValidationModal(this.discApplyOptionNotSelected);
    } else if (((parseFloat(this.discountForm.value.Value) <= 0.00) || (parseFloat(this.discountForm.value.Value) > 100.00)) &&
      (parseInt(this.discountForm.value.Type, 10) === EnumMerchDiscount.Percentage)) {
      this.openValidationModal(this.PercentageValidation);
    } else if ((parseFloat(this.discountForm.value.Value) <= 0.00) &&
      (parseInt(this.discountForm.value.Type, 10) === EnumMerchDiscount.Fixed)) {
      this.openValidationModal(this.FixedValidation);
    } else {
      this.loadFormToMerch();
      this.updateDiscount(this.discountDetails);
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: "modal-dialog-centered", backdrop: 'static', keyboard: false });
  }

  openValidationModal(template: TemplateRef<any>) {
    this.validtaionModalRef = this.modalService.show(template, { class: "modal-dialog-centered", backdrop: 'static', keyboard: false });
  }

  openNewModal(template: TemplateRef<any>) {
    this.newModalRef = this.modalService.show(template, {
      class: 'modal-dialog modal-xl modal-dialog-centered', backdrop: 'static',
      keyboard: false
    });
  }

  loadFormToMerch() {
    let tempId: number;
    if (this.isCodeReactivation === true) {
      tempId = this.ReactivateId;
    } else {
      tempId = this.discountId;
    }
    let tempEndDate = '';
    const datepipe: DatePipe = new DatePipe('en');
    if ((this.discountForm.value.EndDate !== '') && (this.discountForm.value.EndDate != null)) {
      const Edate = new Date(this.discountForm.value.EndDate);
      tempEndDate = datepipe.transform(Edate, 'MM/dd/yyyy');
    }
    this.discountDetails = {
      Id: tempId,
      Name: this.discountForm.value.Name.trim(),
      Description: this.discountForm.value.Description ? this.discountForm.value.Description.trim() : '',
      Type: this.discountForm.value.Type,
      Value: this.discountForm.value.Value,
      StartDate: this.discountForm.value.StartDate ? datepipe.transform(new Date(this.discountForm.value.StartDate), 'MM/dd/yyyy') : null,
      EndDate: tempEndDate,
      AccountId: this.discountForm.value.AccountsHead,
      ApplyatMoveIn: this.discountForm.value.ApplyatMoveIn,
      ApplyatTransfer: this.discountForm.value.ApplyatTransfer,
      ApplytoExistingTenants: this.discountForm.value.ApplytoExistingTenants,
      ApplytorWalkInCustomers: this.discountForm.value.ApplytorWalkInCustomers,
      ApplyAutomatically: this.discountForm.value.ApplyAutomatically,
      Remarks: this.discountForm.value.Remarks,
      MerchandiseItems: this.discountForm.value.MerchandiseItems,
      MerchandisePacks: this.discountForm.value.MerchandisePacks,
      StorageFacilities: this.discountForm.value.StorageFacilities,
    };

  }

  updateDiscount(merch: IMerchandisDiscountDetailsActive) {
    this.newModalRef.hide();
    this.merchService.updateMerchandiseDiscountDetails(merch)
      .subscribe((response: any) => {
        if (response.Success === true) {
          this.RecivedID = response.Id;
          this.addToDiscountGrid();
          this.discountForm.reset();
          this.toastr.success('Merchandise Discount saved Successfully', 'Success', this.toasterConfig);
        } else {
          this.toastr.error('Failed to save Merchandise Discount', 'Failure', this.toasterConfig);
        }
      },
        (err: any) => {
          this.toastr.error('Failed to save Merchandise Discount', 'Failure', this.toasterConfig);
        });
    this.discountName = this.discountForm.value.Name;
  }

  onNewDiscount() {
    this.discountForm.reset();
    this.discountForm.controls['AccountsHead'].patchValue(EnumDiscount.DefaultAccountHead);
    this.discountForm.markAsPristine();
    this.openNewModal(this.NewModal);
  }

  onBlurDiscountName(arg) {
    this.isDiscountNameExist = false;
    this.isCodeReactivation = false;
    if (this.discountForm.value.Name.trim() !== '') {
      if (this.discountForm.value.Name.trim() !== this.discountName) {
        this.getIsDiscountNameExist(this.discountForm.value.Name.trim());
      }
    } else {
      this.isDiscountNameExist = false;
    }
  }

  getIsDiscountNameExist(val) {
    this.discountService.getIsMerchDiscountNameExist(val).subscribe((response: any) => {
      if (response !== false) {
        if (response.DeleteFlag === false) {
          this.isDiscountNameExist = true;
        } else if (response.DeleteFlag === true) {
          this.isDiscountNameExist = false;
          this.isCodeReactivation = true;
          this.ReactivateId = response.Id;
        }
      }
    });
  }

  discValuechanged() {
    if (parseInt(this.discountForm.value.Type, 10) === EnumMerchDiscount.Percentage) {
      if ((this.discountForm.value.Value > 100.00)) {
        this.discountForm.controls['Value'].patchValue(100.00);
      }
    } else {
      if ((this.discountForm.value.Value > 9999.99)) {
        this.discountForm.controls['Value'].patchValue(9999.99);
      }
    }
  }

  addToDiscountGrid() {
    const obj = {
      Id: this.RecivedID,
      Name: this.discountDetails.Name,
      Description: this.discountDetails.Description,
      Type: this.discountDetails.Type,
      Value: this.discountDetails.Value,
      StartDate: this.discountDetails.StartDate,
      EndDate: this.discountDetails.EndDate,
      AccountsHead: this.discountDetails.AccountId,
      ApplyatMoveIn: this.discountDetails.ApplyatMoveIn,
      ApplyatTransfer: this.discountDetails.ApplyatTransfer,
      ApplytoExistingTenants: this.discountDetails.ApplytoExistingTenants,
      ApplytorWalkInCustomers: this.discountDetails.ApplytorWalkInCustomers,
      ApplyAutomatically: this.discountDetails.ApplyAutomatically,
      Remarks: this.discountDetails.Remarks,
    };
    this.DiscountList.push(obj);
  }

  returnObj(id, array) {
    const obj = array.find(o => o.Id === id);
    return obj;
  }

  rowSelectedData(args: RowSelectEventArgs) {
    const selectedrowindex: number[] = this.griddata.getSelectedRowIndexes();  // Get the selected row indexes.

    const selectedrecords = this.griddata.getSelectedRecords();  // Get the selected records.
    this.records = selectedrecords;
  }

  checked(e) {
    if (e.target.checked) {
      this.selectedBox.emit(this.DiscountList);
    } else {
      this.selectedBox.emit(this.DiscountList);
    }
  }

  checkAll(ev) {
    this.DiscountList.forEach(x => x.Active = ev.target.checked);
    this.selectedBox.emit(this.DiscountList);
  }

  isAllChecked() {
    return this.DiscountList.every(_ => _.Active);
  }

  GetAccountHeads() {
    this.generalService.getAccType(this.EnumDiscount.DefaultAccountHead).subscribe((res: IAccType[]) => {
      this.AccountHeads = res;
    });
  }

  returnToPopup() {
    this.discountForm.reset();
    this.isDiscountNameExist = false;
    this.modalRef.hide();
    this.newModalRef.hide();
  }

  confirmCancelForm(template) {
    if (this.discountForm.dirty === true) {
      this.openModal(template);
    } else {
      this.isDiscountNameExist = false;
      this.newModalRef.hide();
    }
  }

  setMandatoryDiscountsField() {
    this.generalService.GetMandatoryFields(null, 'discount-page.component.html', 'discountForm')
      .subscribe((response: IGetPermissionMandatoryField) => {
        var data = response;
        if (data.Form.ListOfProperties.length != 0) {
          this.discountReqList = data.Form.ListOfProperties;
          data.Form.ListOfProperties.forEach(field => {
            if (field.Required) {
              if (this.discountForm.get(field.Name)) {
                if (field.Name == 'Name' || field.Name == 'Description') {
                  this.discountForm.get(field.Name).setValidators([Validators.required, this.generalService.noWhitespaceValidator]);
                } else if (field.Name == 'Value') {
                  this.discountForm.get(field.Name).setValidators([Validators.required, Validators.pattern(this.positiveNumberPattern1)]);
                } else {
                  this.discountForm.get(field.Name).setValidators([Validators.required]);
                }
              }
            } else {
              if (this.discountForm.get(field.Name)) {
                if (field.Name == 'Name' || field.Name == 'Description') {
                  this.discountForm.get(field.Name).setValidators([this.generalService.noWhitespaceValidator]);
                } else if (field.Name == 'Value') {
                  this.discountForm.get(field.Name).setValidators([Validators.pattern(this.positiveNumberPattern1)]);
                } else {
                  this.discountForm.get(field.Name).setValidators(null);
                }
              }
            }
            if (this.discountForm.get(field.Name))
              this.discountForm.get(field.Name).reset();
          });
          this.discountForm.updateValueAndValidity();
        }
      })
  }
}
